
      var _circle, _path, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDataUsage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 32.313,
  r: 2.063,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 27.133c-1.426-1.416-3.364-2.2-5.5-2.2s-4.074.784-5.5 2.2M11 22.245C13.882 19.589 17.5 17.5 23 18M5.867 17.046C10.128 13.174 15 10.5 23 11",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 13c0-1.5 1.167-3 3.5-3 3.5 0 4.375 3.636 2.625 5.09-1.75 1.456-2.625.728-2.625 2.91",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 31.5,
  cy: 22.5,
  r: 1,
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\">\r\n  <circle cx=\"22\" cy=\"32.3125\" r=\"2.0625\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M27.5 27.1333C26.0744 25.7168 24.1358 24.9333 22 24.9333C19.8642 24.9333 17.9256 25.7168 16.5 27.1333\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n  <path d=\"M11 22.2448C13.8822 19.589 17.5 17.5 23 17.9999\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n  <path d=\"M5.8667 17.046C10.1284 13.1743 15 10.5 23 11\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n  <path d=\"M28 13C28 11.5 29.1667 10 31.5 10C35 10 35.875 13.6364 34.125 15.0909C32.375 16.5455 31.5 15.8182 31.5 18\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n  <circle cx=\"31.5\" cy=\"22.5\" r=\"1\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/data-usage.07807a61f1187305466cab4b28b3f704.svg"),
        {
          React: SvgDataUsage,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      